import styled              from 'styled-components';

import { LoadingVariants } from 'src/components/common/loading';

import { cssFlexRow,
         cssFlexColumn,
         themeColors,
         Typo,
         themeTypos,
         typoAsCSS       } from 'src/providers/theme/shared';



type IconListLookAndFeel = {
  itemHeight: number;

  paddings: number[];
  gap: number;

  loadingVariant: LoadingVariants;

  bgColor: string;
  busyBgColor: string;
  iconColor: string;
  labelColor: string;
  busyLabelColor: string;
  borderColor: string;

  labelTypo: Typo;
}

const iconlist_light: IconListLookAndFeel = {
  itemHeight: 116,

  paddings: [0, 0, 0, 20],
  gap: 20,

  loadingVariant: 'lightblue24',

  bgColor: 'transparent',
  busyBgColor: themeColors.SecondaryGray1,
  iconColor: themeColors.PrimaryWhite,
  labelColor: themeColors.PrimaryBlack,
  busyLabelColor: themeColors.SecondaryGray4,
  borderColor: themeColors.SecondaryGray3,

  labelTypo: themeTypos.GRTSKREG_W400_S12_LH16,
}

export type IconListVariants = 'light';

export const iconlist_variants: Map<IconListVariants, IconListLookAndFeel> = 
  new Map<IconListVariants, IconListLookAndFeel>([
    ['light', iconlist_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: IconListLookAndFeel;
}>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 10px 20px;
  gap: 10px;
`

export const ListItem = styled.div<{
  lookAndFeel: IconListLookAndFeel;
  isBusy: boolean;
}>`
  ${cssFlexColumn};
  justify-content: space-between;

  height: ${(args) => args.lookAndFeel.itemHeight}px;
  cursor: pointer;
  padding: 19px 16px 19px 20px;
  gap: 12px;

  background-color: ${ themeColors.SurfaceBackgroundSecondary };
  border-radius: 8px;
`

export const ListItemIconContainer = styled.div<{
  colorContainer: string;
}>`
  width: 42px;
  height: 34px;
  background-color: ${(args) => args.colorContainer};
  padding: 7px 11px;
  border-radius: 999px;
  justify-content: center;
  align-items: center;

  box-shadow: 0px 4px 4px ${(args) => args.colorContainer}1a;
`
export const ListItemIcon = styled.div<{
  lookAndFeel: IconListLookAndFeel;
  isBusy: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: ${(args) => args.lookAndFeel.iconColor};

  & svg {
    width: 20px;
    height: 20px;
    display: block;
  }
`

export const ListItemLabel = styled.div<{
  lookAndFeel: IconListLookAndFeel;
  isBusy: boolean;
}>`
  ${cssFlexRow};
  align-items: center;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;

  ${(args) => typoAsCSS(args.lookAndFeel.labelTypo)}
  color: ${(args) => args.isBusy ? args.lookAndFeel.busyLabelColor : args.lookAndFeel.labelColor};
`
